module.exports = __webpack_public_path__ + "static/media/ranking.3b335b46.svg";